// WP50 P5 account forms ([data-auth]): show/hide password, Caps Lock hint, inline "required" errors, busy Sign in button.

function fieldError(input: HTMLInputElement): HTMLElement | null {
  const id = (input.getAttribute("aria-describedby") ?? "").split(" ").find((x) => x.endsWith("-error"));
  return id ? document.getElementById(id) : null;
}

function setError(input: HTMLInputElement, message: string | null): void {
  const box = fieldError(input);
  if (message) input.setAttribute("aria-invalid", "true");
  else input.removeAttribute("aria-invalid");
  if (box) { box.textContent = message ?? ""; box.hidden = !message; }
}

// Capture phase, so an empty field stops the post before shell.ts marks the button busy.
document.addEventListener("submit", (ev) => {
  const form = ev.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute("data-auth")) return;
  const submit = form.querySelector<HTMLButtonElement>("button[type='submit']");
  if (submit?.getAttribute("aria-busy") === "true") { ev.preventDefault(); return; } // already posting
  const empty = Array.from(form.querySelectorAll<HTMLInputElement>("input[data-required]")).filter((i) => i.value.trim() === "");
  form.querySelectorAll<HTMLInputElement>("input[data-required]").forEach((i) => setError(i, empty.includes(i) ? i.dataset.required ?? "" : null));
  if (empty[0]) { ev.preventDefault(); empty[0].focus(); return; }
  // Enter in the password box posts through requestSubmit() with no submitter, so shell.ts cannot mark the button.
  if (submit && !(ev as SubmitEvent).submitter && !form.hasAttribute("hx-post")) {
    submit.setAttribute("aria-busy", "true");
    window.setTimeout(() => submit.removeAttribute("aria-busy"), 8000);
  }
}, true);

document.addEventListener("input", (ev) => {
  const input = ev.target;
  if (input instanceof HTMLInputElement && input.hasAttribute("aria-invalid") && input.closest("[data-auth]")) setError(input, null);
});

function capsHint(ev: Event): void {
  const input = ev.target;
  if (!(input instanceof HTMLInputElement) || !(ev instanceof KeyboardEvent) || typeof ev.getModifierState !== "function") return;
  const hint = input.closest("[data-auth]")?.querySelector<HTMLElement>("[data-caps-hint]");
  if (hint && input.matches("[type='password'], [data-pw-shown]")) hint.hidden = !ev.getModifierState("CapsLock");
}
document.addEventListener("keydown", capsHint);
document.addEventListener("keyup", capsHint);

document.addEventListener("click", (ev) => {
  const toggle = ev.target instanceof Element ? ev.target.closest<HTMLButtonElement>("[data-pw-toggle]") : null;
  const input = toggle?.parentElement?.querySelector<HTMLInputElement>("input");
  if (!toggle || !input) return;
  const show = input.type === "password";
  input.type = show ? "text" : "password";
  input.toggleAttribute("data-pw-shown", show);
  toggle.setAttribute("aria-pressed", String(show));
  toggle.setAttribute("aria-label", show ? "Hide password" : "Show password");
  input.focus();
});
